import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getScreenPermissions = async (screenId) => {
	const { data } = await axios.get(`${API}/app/permissions`, {
		params: { screen_id: screenId },
	});
	return data;
};
